import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  /** @type {'dark' | 'light'} */
  mode: 'dark',
  sidebarCollapsed: false,
  /** @type {Record<string, boolean>} */
  filterDrawerOpen: {},
}

const uiShellSlice = createSlice({
  name: 'uiShell',
  initialState,
  reducers: {
    toggleMode(state) {
      state.mode = state.mode === 'dark' ? 'light' : 'dark'
    },
    setMode(state, action) {
      state.mode = action.payload
    },
    setSidebarCollapsed(state, action) {
      state.sidebarCollapsed = action.payload
    },
    toggleSidebar(state) {
      state.sidebarCollapsed = !state.sidebarCollapsed
    },
  },
})

export const { toggleMode, setMode, setSidebarCollapsed, toggleSidebar } = uiShellSlice.actions
export default uiShellSlice.reducer
